import React, { useState } from 'react';
import UserIcon from '../icons/UserIcon';

interface AccountFormData {
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  securityQuestion: string;
  securityAnswer: string;
}

const AccountDetails: React.FC = () => {
  const [formData, setFormData] = useState<AccountFormData>({
    firstName: 'Briii',
    lastName: 'Smith',
    middleName: '',
    email: 'briii_smith@example.com',
    securityQuestion: 'What is your mother`s maiden name?',
    securityAnswer: 'Jane Doe'
  });

  const handleInputChange = (field: keyof AccountFormData, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const securityQuestions = [
    { value: '', label: 'Select a security question' },
    { value: 'pet', label: 'What was the name of your first pet?' },
    { value: 'school', label: 'What was the name of your elementary school?' },
    { value: 'city', label: 'In what city were you born?' },
    { value: 'mother', label: 'What is your mother\'s maiden name?' },
    { value: 'car', label: 'What was the make of your first car?' }
  ];

  return (
    <div className="account-details">
      <div className="account-section">
        <h2 className="section-title">
          <UserIcon className="section-icon" />
          Account Details
        </h2>
        
        <div className="personal-info-section">
          <h3 className="subsection-title">Personal Information</h3>
          
          <div className="form-row">
            <div className="form-group">
              <label className="form-label" htmlFor="firstName">First Name</label>
              <input
                id="firstName"
                type="text"
                className="form-input"
                value={formData.firstName}
                onChange={(e) => handleInputChange('firstName', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="lastName">Last Name</label>
              <input
                id="lastName"
                type="text"
                className="form-input"
                value={formData.lastName}
                onChange={(e) => handleInputChange('lastName', e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label" htmlFor="middleName">Middle Name</label>
              <input
                id="middleName"
                type="text"
                className="form-input"
                placeholder="Optional"
                value={formData.middleName}
                onChange={(e) => handleInputChange('middleName', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email"
                className="form-input"
                value={formData.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="security-settings-section">
          <h3 className="subsection-title">Security Settings</h3>
          
          <div className="form-row">
            <div className="form-group">
              <label className="form-label" htmlFor="securityQuestion">Security Question</label>
              <select
                id="securityQuestion"
                className="form-input form-select"
                value={formData.securityQuestion}
                onChange={(e) => handleInputChange('securityQuestion', e.target.value)}
              >
                {securityQuestions.map((question) => (
                  <option key={question.value} value={question.value}>
                    {question.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="securityAnswer">Security Answer</label>
              <input
                id="securityAnswer"
                type="text"
                className="form-input"
                placeholder="Enter your security answer"
                value={formData.securityAnswer}
                onChange={(e) => handleInputChange('securityAnswer', e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button type="button" className="btn-save btn-enhanced">
            Save Changes
          </button>
          <button type="button" className="btn-cancel btn-enhanced">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;